/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Suggestions_Welcome_2Inputs */

const es_chat_suggestions_welcome_2 = /** @type {(inputs: Chat_Suggestions_Welcome_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bienvenido ${i?.name}. ¿Qué consulta querés resolver?`)
};

const en_chat_suggestions_welcome_2 = /** @type {(inputs: Chat_Suggestions_Welcome_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Welcome ${i?.name}. What would you like to work on?`)
};

/**
* | output |
* | --- |
* | "Welcome {name}. What would you like to work on?" |
*
* @param {Chat_Suggestions_Welcome_2Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_suggestions_welcome_2 = /** @type {((inputs: Chat_Suggestions_Welcome_2Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestions_Welcome_2Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_suggestions_welcome_2(inputs)
	return en_chat_suggestions_welcome_2(inputs)
});
export { chat_suggestions_welcome_2 as "chat.suggestions.welcome_2" }